var _defs, _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBgElementRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 420 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M58.802 375.586l-.707-.707L340.938 92.036l.707.707zM85.666 334.568l-.707-.707L367.802 51.018l.707.707z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 299.953,
    cy: 118.934,
    r: 71.5,
    transform: "rotate(-135 299.953 118.934)",
    stroke: "#DEB06A"
  })));
}

var MemoSvgBgElementRight = /*#__PURE__*/React.memo(SvgBgElementRight);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIwIiBoZWlnaHQ9IjQyMCIgdmlld0JveD0iMCAwIDQyMCA0MjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjU4LjgwMjciIHk9IjM3NS41ODYiIHdpZHRoPSIxIiBoZWlnaHQ9IjQwMCIgdHJhbnNmb3JtPSJyb3RhdGUoLTEzNSA1OC44MDI3IDM3NS41ODYpIiBmaWxsPSIjMTQxNDE0Ii8+CjxyZWN0IHg9Ijg1LjY2NiIgeT0iMzM0LjU2OCIgd2lkdGg9IjEiIGhlaWdodD0iNDAwIiB0cmFuc2Zvcm09InJvdGF0ZSgtMTM1IDg1LjY2NiAzMzQuNTY4KSIgZmlsbD0iIzE0MTQxNCIvPgo8Y2lyY2xlIGN4PSIyOTkuOTUzIiBjeT0iMTE4LjkzNCIgcj0iNzEuNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTEzNSAyOTkuOTUzIDExOC45MzQpIiBzdHJva2U9IiNERUIwNkEiLz4KPC9zdmc+Cg==";
export { MemoSvgBgElementRight as ReactComponent };